export default "__VITE_ASSET__2da45790__"